import { Pipe, PipeTransform } from '@angular/core';
import { ReportDecimalType, ReportOutputModel } from '../../../../shared/models/report.model';
import { DecimalPipe } from '@angular/common';
import { User } from '../../../../shared/models/user.model';
import { TimeAgoPipe } from '../../../../shared/pipes/time-ago.pipe';
import { DateFormatPipe } from '../../../../shared/pipes/jdate.pipe';
import { Market } from '../../../../shared/models/market.model';
import { Currency } from '../../../../shared/models/currency.model';
import moment from 'moment-jalaali';
import Big from 'big.js';
import { SecureImageDirective } from '../../../../shared/directives/img-resolver.directive';
import { HttpClient } from '@angular/common/http';

@Pipe({
  name: 'reportOutput'
})
export class ReportOutputPipe implements PipeTransform {

  fetchUserImage(imageUrl: string, userId: number) {
    if (imageUrl !== 'https://cdn.nesoex.com/assets/user.png') {
      this.http.get(imageUrl, { responseType: 'blob' }).subscribe((response) => {
        // Creating an object URL for the blob data and setting it as the src of the image
        const reader = new FileReader();
        reader.onloadend = () => {
          const img = document.getElementsByClassName(`avatar-${userId}`) as HTMLCollectionOf<HTMLImageElement> | null;
          if (img && img.length === 1) {
            img[0].src = reader.result as string;
          }
        };
        reader.readAsDataURL(response);
      });
    }

  }

  constructor(private decimal: DecimalPipe, private timeAgo: TimeAgoPipe, private dateFormat: DateFormatPipe, private http: HttpClient) {
  }

  transform(value: unknown, output: ReportOutputModel): string {
    if (value === null) {
      return '-';
    }
    switch (output.type) {
      case 'code':
        return `<code class="text-white no-wrap">${value}</code>`;
      case 'decimal':
        if ((value as ReportDecimalType).value) {
          return `<bdi class="${output.extraParams['greenRedColor'] ? (Big((value as ReportDecimalType).value).gt(0) ? 'text-primary' : 'text-danger') : ''}">${(value as ReportDecimalType).prefix ?? ''} <bdi class="${output.extraParams['greenRedColor'] ? (Big((value as ReportDecimalType).value).gte(0) ? 'text-primary' : 'text-danger') : ''}">${this.decimal.transform((value as ReportDecimalType).value, '1.0-12')}</bdi> ${(value as ReportDecimalType).suffix ?? ''}</bdi>`;
        } else {
          return `<bdi class="${output.extraParams['greenRedColor'] ? (Big(value as string).gt(0) ? 'text-primary' : 'text-danger') : ''}">${value}</bdi>`;
        }
      case 'integer':
        return `<bdi class="${output.extraParams['greenRedColor'] ? (Big(value as string).gt(0) ? 'text-primary' : 'text-danger') : ''}">${value as string}</bdi>`;
      case 'ltrString':
        return `<bdi class="text-white no-wrap font-monospace">${value}</bdi>`;
      case 'rtlString':
        return `<bdi class="no-wrap">${value}</bdi>`;
      case 'dateTime':
        return `<bdi class="no-wrap" title="${this.dateFormat.transform(value as string, 'HH:mm jYYYY/jMM/jDD')}">${this.timeAgo.transform(moment.utc(value as string).local().format('YYYY-MM-DD HH:mm:ss') as string)}</bdi>`;
      case 'date':
        return `<bdi class="no-wrap">${this.dateFormat.transform(value as string, 'jDD jMMMM jYYYY')}</bdi>`;
      case 'market':
        return `<div class="d-flex align-items-center gap-1 no-wrap">
<img height="20" width="20" src="${(value as Market).baseCurrency.iconPath}"/>
           <span>${(value as Market).baseCurrency.name}</span>
           <span>-</span>
           <img height="20" width="20" src="${(value as Market).quoteCurrency.iconPath}"/>
           <span>${(value as Market).quoteCurrency.name}</span>
</div>`;
      case 'currency':
        return `<div class="d-flex align-items-center gap-2 no-wrap">
<img height="20" width="20" src="${(value as Currency).iconPath}"/>
           <span>${(value as Currency).name}</span>
</div>`;
      case 'user':

        if ((value as User).firstName) {
          this.fetchUserImage((value as any).image, (value as User).id);
          return `
<div class="d-flex align-items-center gap-2">
<img  class="report-avatar avatar-${(value as User).id}"  src="https://cdn.nesoex.com/assets/user.png">
<a class="text-primary no-wrap" href="/dashboard/user/${(value as User).id}">${(value as User).firstName} ${(value as User).lastName}</a>
</div>
`;
        } else if ((value as User).email) {
          this.fetchUserImage((value as any).image, (value as User).id);
          return `
<div class="d-flex align-items-center gap-2">
<img  class="report-avatar avatar-${(value as User).id}" src="https://cdn.nesoex.com/assets/user.png">
<a class="text-primary no-wrap" href="/dashboard/user/${(value as User).id}">${(value as User).email}</a>
</div>
`;
        } else if ((value as User).phone) {
          this.fetchUserImage((value as any).image, (value as User).id);
          return `
<div class="d-flex align-items-center gap-2">
<img  class="report-avatar avatar-${(value as User).id}" src="https://cdn.nesoex.com/assets/user.png">
<a class="text-primary no-wrap" href="/dashboard/user/${(value as User).id}">${(value as User).phone}</a>
</div>
`;
        } else {
          return value as string;
        }
      default:
        return value as string;
    }
  }

}
